/* Copyright (c) 2024 Xperi. All Rights Reserved.  */

import {
    Configuration,
    ConfigurationParameters,
    DefaultApi,
    IpAddress,
    MyWanIpAddressGetRequest,
} from 'client-code/my-wan-ip';
import { APPLICATION_FEATURE_AREA } from '../../config';
import { CommonHeaders } from '../CommonHeaders';
import { Constants } from '../constants';
import { DeviceModel } from '../device';
import { IMyWanIpServiceRepository } from '../interfaces/IMyWanIpServiceRepository';
import { Log } from '../logging/Log';
import { TServicesParams, TIpAddress } from '../types';
import { UniqueIdentifier } from '../utils/UniqueIdentifier';

export class MyWanIpServiceRepositoryImpl implements IMyWanIpServiceRepository {
    private static myWanIp: string | undefined;

    TAG: string = 'MyWanIpServiceRepositoryImpl';

    mParams: TServicesParams;

    constructor(params: TServicesParams) {
        this.mParams = params;
    }

    private async getMyWanIpFromService(): Promise<IpAddress> {
        try {
            const commonHeaders = new CommonHeaders(APPLICATION_FEATURE_AREA.STARTUP).headers;
            const configurationParameters: ConfigurationParameters = {
                basePath: this.mParams.basePath,
                baseOptions: {
                    timeout: Constants.SERVICE_CONNECTION_TIMEOUT,
                    headers: commonHeaders,
                },
            };
            const configuration = new Configuration(configurationParameters);
            const requestParameters: MyWanIpAddressGetRequest = {
                applicationName: DeviceModel.getTiVoSettings().getAppName(),
                originRequestId: UniqueIdentifier.generateOriginRequestId(),
            };
            const myWanIpApi = new DefaultApi(configuration);
            const myWanIpData = await myWanIpApi.myWanIpAddressGet(requestParameters);
            return myWanIpData.data;
        } catch (error) {
            Log.e(this.TAG, 'getMyWanIpFromService', error);
            throw error;
        }
    }

    async getMyWanIpAddress(): Promise<TIpAddress> {
        try {
            const oldWanIp = MyWanIpServiceRepositoryImpl.myWanIp || '';
            const newWanIp = (await this.getMyWanIpFromService()).ipAddress || '';
            if (newWanIp) MyWanIpServiceRepositoryImpl.myWanIp = newWanIp;
            return {
                newWanIp,
                oldWanIp,
            };
        } catch (error) {
            Log.e(this.TAG, 'error', error);
            throw error;
        }
    }
}
